module.exports = __webpack_public_path__ + "img/web_price_deluxe.4d6090e9.png";